import { registerPlugin } from '@capacitor/core';
const Releasebird = registerPlugin('Releasebird', {
    web: () => import('./web').then(m => new m.ReleasebirdWeb()),
});
export * from './definitions';
export { Releasebird };
//# sourceMappingURL=index.js.map